export default __webpack_public_path__ + "static/media/anniversary4.e1ec4540.webp";